import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-dialog-confirm-space-email',
  templateUrl: './dialog-confirm-space-email.component.html',
  styleUrls: ['./dialog-confirm-space-email.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogModule,
  ],
})
export class DialogConfirmSpaceEmailComponent {
  emailAddress: string = '';

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmSpaceEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogEmail,
  ) {
    this.emailAddress = data.emailAddress;
  }
}

export interface IDialogEmail {
  emailAddress: string;
}
